import { render, staticRenderFns } from "./LotteryConfig.vue?vue&type=template&id=3c309ea6&"
import script from "./LotteryConfig.vue?vue&type=script&lang=js&"
export * from "./LotteryConfig.vue?vue&type=script&lang=js&"
import style0 from "./LotteryConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports